import React from 'react';
import { Button, Grid } from '@mui/material';

import { PropertyTextInput } from '@paragon/client-tools';
import { getClientUrls, LoginTypography } from '@paragon/login-tools';

import { matchUrlPattern } from '../urlPattern';
import { useAppSelector } from './hooks';

export function SharedComponentSetLookupCodeControl() {
  const { designUrl } = useAppSelector(getClientUrls);
  const errorLoadingSharedComponentSet = useAppSelector(
    (state) => state.sharedComponentSet.errorLoadingSharedComponentSet,
  );
  const urlParameters = matchUrlPattern(window.location.pathname);
  const collectionIdentifier = urlParameters.projectGuid;

  const [sharedComponentSetLookupCode, setSharedComponentSetLookupCode] = React.useState<string>(
    collectionIdentifier && collectionIdentifier.length === 10 ? collectionIdentifier : '',
  );
  const [error, setError] = React.useState<string | null>(
    errorLoadingSharedComponentSet ? 'Error loading Shared Component Set. Check your lookup code.' : null,
  );
  return (
    <Grid container spacing={1} sx={{ justifyContent: 'center', alignItems: 'center', width: '100%' }}>
      <Grid size={9}>
        <PropertyTextInput
          property={'Lookup Code from TDD'}
          value={sharedComponentSetLookupCode}
          submit={setSharedComponentSetLookupCode}
          fullWidth
          error={error !== null}
        />
      </Grid>
      <Grid size={3}>
        <Button
          variant={'outlined'}
          sx={{ width: '100%' }}
          onClick={() => {
            if (sharedComponentSetLookupCode.length !== 10) {
              setError('Lookup code should be 10 characters');
              return;
            }
            window.location.href = `${designUrl}${sharedComponentSetLookupCode}`;
          }}
        >
          Open
        </Button>
      </Grid>
      {error && (
        <Grid size={12}>
          <LoginTypography variant="caption">{error}</LoginTypography>
        </Grid>
      )}
    </Grid>
  );
}
